import './table.scss';
import { Fragment } from 'react';
import { Card } from 'reactstrap';
import { ChevronDown } from 'react-feather';
import { useTranslation } from 'react-i18next';
import DataTable from 'react-data-table-component';
import '@styles/react/libs/react-select/_react-select.scss';
import '@styles/react/libs/tables/react-dataTable-component.scss';

interface TableProps {
  data: any[];
  columns: any;
  rowsPerPage?: number;
  pagination: any;
  header?: any;
  onSort?: (column: any, direction: any) => void;
}

const Table = (props: TableProps) => {
  const { t } = useTranslation();
  const HeaderComponent = props.header;

  const handleSort = (column: any, direction: any) => {
    if (props.onSort) {
      props.onSort(column, direction);
    }
  };

  return (
    <Fragment>
      <Card className="data-table overflow-hidden d-flex">
        <div className="react-dataTable dataTable-content">
          <DataTable
            noHeader
            subHeader
            sortServer
            pagination
            responsive
            paginationServer
            noDataComponent={t('NO_DATA_TABLE')}
            columns={props.columns}
            sortIcon={<ChevronDown />}
            className="react-dataTable"
            paginationComponent={props.pagination}
            data={props.data}
            subHeaderComponent={<HeaderComponent />}
            onSort={handleSort}
          />
        </div>
      </Card>
    </Fragment>
  );
};

export default Table;
